import React from "react"
import { FormattedNumber } from "react-intl"
import { DataTableCellNumeric } from "@walmart-web/livingdesign-components"
import { concatClassNames } from "helpers/jsxHelpers"
import "./index.scss"

interface PointsCellProps {
	children: number
	isPercentage?: boolean
}

const PointsCell: React.FC<PointsCellProps> = ({
	children,
	isPercentage = false,
}) => {
	const formattedValue = isPercentage ? children * 100 : children
	return (
		<DataTableCellNumeric
			UNSAFE_style={{ textAlign: "right" }}
			UNSAFE_className="percentage-cell"
		>
			<div
				className={concatClassNames([children < 0 ? "negative" : "positive"])}
			>
				<FormattedNumber
					value={formattedValue}
					minimumFractionDigits={2}
					maximumFractionDigits={2}
					signDisplay="always"
				>
					{(value: number) => `${value} pts`}
				</FormattedNumber>
			</div>
		</DataTableCellNumeric>
	)
}

export default PointsCell
